import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../components/button';
import SvgIcon from '../../../../components/svg-icon/svg-icon';
import { ConfirmationContainer, CancelIconContainer, OkIconContainer } from './styled';
import OkIcon from './icons/ok.svg';
import CancelIcon from './icons/cancel.svg';

class ArchiveCourse extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showArchiveConfirmation: false
        };
    }

   showArchiveCourseConfirmation = (status) => {
       this.setState({
           showArchiveConfirmation: status
       });
   };

    archiveCourse = () => {
        const {
            productId,
            id: courseId,
            version: courseVersion
        } = this.props.selectedCourse;
        this.props.archiveSelectedCourse({ productId, courseId, courseVersion });
    };

    render() {
        if (this.state.showArchiveConfirmation) {
            return (
                <ConfirmationContainer>
                    <CancelIconContainer onClick={() => this.showArchiveCourseConfirmation(false)}>
                        <SvgIcon icon={CancelIcon} />
                    </CancelIconContainer>
                    <OkIconContainer onClick={this.archiveCourse}>
                        <SvgIcon icon={OkIcon} />
                    </OkIconContainer>
                </ConfirmationContainer>
            );
        }

        return <Button handleOnClick={() => this.showArchiveCourseConfirmation(true)} label="Archive" warning />;
    }
}

ArchiveCourse.propTypes = {
    archiveSelectedCourse: PropTypes.func.isRequired,
    selectedCourse: PropTypes.object.isRequired
};

export default ArchiveCourse;



// WEBPACK FOOTER //
// ./app/containers/default-courses/components/archive-course/archive-course.js